import { Injectable } from "@angular/core";

const key = 'tabcount';

/**
 * Service to keep track of how many browser tabs the
 * user has open.
 */
@Injectable({
    providedIn: 'root'
})
export class TabRegistrationService {
    /**
     * Initialize the tab registration service.
     */
    public initialize(): void {
        if (!this._initialized) {
            this.register();
            window.addEventListener('unload', () => this.unregister());
            this._initialized = true;
        }
    }

    private _initialized = false;

    /**
     * Record the fact that the user has opened the current tab.
     */
    private register(): void {
        localStorage.setItem(key, (this.getInstanceCount() + 1).toString());
    }

    /**
     * Record the fact that the user is closing this tab.
     */
    private unregister(): void {
        localStorage.setItem(key, (Math.max(this.getInstanceCount() - 1, 0)).toString());
    }

    /**
     * Get the number of browser tabs the user has open, including
     * the current tab. If this is the only tab, this function
     * returns 1. If this function returns 0, then you probably
     * forgot to call initialize(), or localStorage is disabled.
     */
    public getInstanceCount(): number {
        let serializedCount = localStorage.getItem(key);
        return serializedCount ? parseInt(serializedCount) : 0;
    }
}
